import { render, staticRenderFns } from "./BaseChevron.vue?vue&type=template&id=3bd6a658&"
import script from "./BaseChevron.vue?vue&type=script&lang=js&"
export * from "./BaseChevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports